import { css } from 'styled-components';

const boxShadowColorBase = 'rgb(0 0 0 / 5%)';
const boxShadowColorHover = 'rgb(0 0 0 / 12%)';
const boxShadowColorListbox = 'rgb(0 0 0 / 7%)';
const boxShadowOffsetXBase = 0;
const boxShadowOffsetYBase = 4;
const boxShadowOffsetYList = 7;
const boxShadowOffsetYListbox = 5;
const boxShadowBlurRadiusBase = 10;
const boxShadowBlurRadiusListbox = 64;
const boxShadowSpreadRadiusBase = 0;
const boxShadowSpreadRadiusDialogs = 1;
css`
  box-shadow: ${boxShadowOffsetXBase}px ${boxShadowOffsetYBase}px ${boxShadowBlurRadiusBase}px
    ${boxShadowSpreadRadiusBase}px ${boxShadowColorBase};
`;
css`
  box-shadow: ${boxShadowOffsetXBase}px ${boxShadowOffsetYBase}px ${boxShadowBlurRadiusBase}px
    ${boxShadowSpreadRadiusBase}px ${boxShadowColorHover};
`;
const boxShadowDialogs = css`
  box-shadow: ${boxShadowOffsetXBase}px ${boxShadowOffsetYBase}px ${boxShadowBlurRadiusBase}px
    ${boxShadowSpreadRadiusDialogs}px ${boxShadowColorHover};
`;
const boxShadowLists = css`
  box-shadow: ${boxShadowOffsetXBase}px ${boxShadowOffsetYList}px ${boxShadowBlurRadiusListbox}px
    ${boxShadowSpreadRadiusBase}px ${boxShadowColorListbox};
`;
const boxShadowListboxes = css`
  box-shadow: ${boxShadowOffsetXBase}px ${boxShadowOffsetYListbox}px ${boxShadowBlurRadiusListbox}px
    ${boxShadowSpreadRadiusBase}px ${boxShadowColorListbox};
`;

export { boxShadowBlurRadiusBase, boxShadowBlurRadiusListbox, boxShadowColorBase, boxShadowColorHover, boxShadowColorListbox, boxShadowDialogs, boxShadowListboxes, boxShadowLists, boxShadowOffsetXBase, boxShadowOffsetYBase, boxShadowOffsetYList, boxShadowOffsetYListbox, boxShadowSpreadRadiusBase, boxShadowSpreadRadiusDialogs };
//# sourceMappingURL=box-shadow.js.map
